module.exports = __webpack_public_path__ + "img/748d8abf32d05f07abdbf57c4231571f.svg";